import React from 'react'
import logoForce from '../assets/images/logo-force.jpg'
import logoTI from '../assets/images/logo-ti.png'
import logoDBI from '../assets/images/logo-dbi.png'
import logoALX from '../assets/images/logo-alx.png'
import logoBSS from '../assets/images/logo-bss.jpg'
import logoDS from '../assets/images/logo-ds.png'
import logoIF from '../assets/images/logo-if.png'



const Footer = () => {
  return (
    <section className='__footer'>
      <div className='__footer-logos'>
        <img src={logoForce} alt="Force Technology"/>
        <img src={logoTI} alt="Teknologisk Institut"/>
        <img src={logoDBI} alt="DBI Brand og Sikring"/>
        <img src={logoALX} alt="Alexandra Instituttet"/>
        <img src={logoBSS} alt="Aarhus University BTECH"/>
        <img src={logoDS} alt="Dansk Standard"/>
        <div className='__footer-if-logo mt-4 flex-column'>
          <p>Modstandsdygtig.dk er støttet af</p>
          <img src={logoIF} alt="Industriens Fond"/>
        </div>
      </div>

    </section>
    
  )
}

export default Footer